import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useProjectsPersonnelQuery({ personnelId, projectId }) {
  return useQuery({
    queryKey: ['projects', projectId, 'personnel', personnelId],
    queryFn: async () => {
      const response = await axios.get(
        `/projects/${projectId}/personnel/${personnelId}`,
      );

      return response.data;
    },
    select: (data) =>
      formatData({
        data,
        resourceTypes: [
          'company',
          'companyRole',
          'fieldValue',
          'lineManager',
          'profilePhoto',
          'subcontractor',
          'userCompanyRole',
        ],
      }),
  });
}
